(function () {
  if (customElements.get('healr-video')) return;

  class HealrVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || this._bound) return;
      this._bound = true;

      // Click anywhere on the video toggles play/pause (the play overlay is
      // purely visual — pointer-events:none — so clicks fall through to here).
      this.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggle();
      });

      // Keep the overlay state in sync with the ACTUAL video state.
      this.video.addEventListener('play', () => this.classList.add('is-playing'));
      this.video.addEventListener('pause', () => this.classList.remove('is-playing'));
      this.video.addEventListener('ended', () => this.classList.remove('is-playing'));
    }

    toggle() {
      const v = this.video;
      if (!v.paused) {
        v.pause();
        return;
      }
      if (v.readyState === 0) v.load();

      // 1) Try a normal (unmuted) play — works on the live/published site.
      const attempt = v.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(() => {
          // 2) Blocked (e.g. unmuted programmatic play inside the sandboxed
          //    theme-editor iframe). Start MUTED, then unmute once rolling.
          v.muted = true;
          const muted = v.play();
          if (muted && typeof muted.then === 'function') {
            muted.then(() => { v.muted = false; }).catch(() => {
              v.setAttribute('controls', ''); // last resort: native controls
            });
          }
        });
      }
    }
  }

  customElements.define('healr-video', HealrVideo);
})();
